import Vue from 'vue'
import Vuex from 'vuex'
import Storage from '@/helpers/storage'
import Api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {

        user: {},

        stats: {},

        settings: {},

        partners: {},

        email: '',

        scroll: false,

        lang: '',

        page: '',

        maintenance: false,

        internet: true,

        leftMenu: false,

        fastPass: false

    },
    mutations: {

        UPDATE_USER: (state, user) => {
            state.user = user
        },

        UPDATE_STATS: (state, stats) => {

            state.stats = stats
        },

        UPDATE_SETTINGS: (state, settings) => {
            state.settings = settings
        },

        UPDATE_PARTNERS: (state, partners) => {
            state.partners = partners
        },

        EMAIL: (state, email) => {
            state.email = email
        },

        SCROLL: (state, bool) => {
            state.scroll = bool
        },

        LANG: (state, lang) => {
            state.lang = lang
        },

        PAGE: (state, page) => {
            state.page = page
        },

        MAINTENANCE: (state, maintenance) => {
            state.maintenance = maintenance
        },

        INTERNET: (state, internet) => {
            state.internet = internet
        },

        LEFTMENU: (state, leftMenu) => {
            state.leftMenu = leftMenu
        },

        UPDATE_FAST_PASS: (state, fastPass) => {
            state.fastPass = fastPass
        },

    },
    getters: {

        user: state => state.user,

        stats: state => state.stats,

        settings: state => state.settings,

        partners: state => state.partners,

        scroll: state => state.scroll,

        lang: state => state.lang,

        page: state => state.page,

        maintenance: state => state.maintenance,

        internet: state => state.internet,

        leftMenu: state => state.leftMenu,

        fastPass: state => state.fastPass

    },
    actions: {

        setUser: (store, user = {}) => store.commit('UPDATE_USER', user),

        disconnect (store) {

            Storage.removeItem('token')
            store.commit('UPDATE_USER', {})
        },

        getUserAsync: function ({ commit, state }) {

            if (state.user && state.user.accounts) {
                return Promise.resolve(state.user)
            }
            return Api.user.getUser()
                .then(user => {
                    commit('UPDATE_USER', user)
                    return user
                })
        },

        getStatsAsync: async function ({ commit, state }) {

            //refresh always stats, but some modules need stats
            return Api.user.getStats()
                .then(stats => {
                    commit('UPDATE_STATS', stats)
                    return stats
                })
        },

        getSettingsAsync: function ({ commit, state }) {
            return Api.user.getSettings()
                .then(settings => {
                    commit('UPDATE_SETTINGS', settings)
                    return settings
                })
        },

        getPartnersAsync: function ({ commit, state }) {
            if (Object.keys(state.partners).length) {
                return state.partners
            }
            return Api.partners.getAll()
                .then(partners => {
                    commit('UPDATE_PARTNERS', partners)
                    return partners
                })
        },

        refreshUser: function ({ commit }) {
            return Api.user.getUser()
                .then(user => {
                    commit('UPDATE_USER', user)
                    return user
                })
        },

        setLang: (store, lang) => store.commit('LANG', lang),

        setPage: (store, page) => store.commit('PAGE', page),

        setMaintenance: (store, maintenance) => store.commit('MAINTENANCE', maintenance),

        setInternetStatus: (store, bool) => store.commit('INTERNET', bool),

        updateLeftMenu: (store, bool) => store.commit('LEFTMENU', bool),

        updateFastPass: (store, bool) => store.commit('UPDATE_FAST_PASS', bool)

    },
    strict: true
})


